import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { environment } from "src/environments/environment";
import { CommonService } from "../../common-service";
import { ListPatientHealthcareAgreementPatientCenterResponse } from "../../responses/orchestrator-schedule/list-patient-healthcare-agreement-patient-center.response";

@Injectable({
    providedIn: 'root'
})
export class PatientHealthcareAgreementService extends CommonService {

    constructor(private httpClient: HttpClient) { super(); }

    public getAllPatientHealthcareAgreementByIdPatient(): Observable<ListPatientHealthcareAgreementPatientCenterResponse> {
        let uri = `PatientHealthcareAgreement`;

        return this.httpClient.get<ListPatientHealthcareAgreementPatientCenterResponse>(environment.urlApiOrchestratorSchedule + uri, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}